import { Fragment } from "react/jsx-runtime";
import { Button, Card, CardBody, CardHeader, Collapse, Input, InputGroup, InputGroupText } from "reactstrap";
import { ChangeNumberTitle, Href } from "../../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { setAccount } from "../../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { dynamicNumber } from "../../../../../../Utils";

const ChangeNumber = () => {
  const { account } = useAppSelector((state) => state.mainSidebar);
  const dispatch = useAppDispatch();
  return (
    <Card>
      <CardHeader onClick={() => dispatch(setAccount(account !== "4" ? "4" : ""))}>
        <a href={Href}>{ChangeNumberTitle}
          <i className={`fa fa-angle-${account === "4" ? "up" : "down"}`} />
        </a>
      </CardHeader>
      <Collapse className={`${account === "4" ? "show" : ""}`}>
        <CardBody className="change-number">
          {dynamicNumber(2).map((item, index) => (
            <Fragment key={index}>
              <h5>Your {item === 1 ? "old" : "new"} country code &amp; phone number</h5>
              <InputGroup>
                <div className="input-group-prepend">
                  <InputGroupText className="form-control m-0">+</InputGroupText>
                </div>
                <Input className="country-code" type="number" placeholder={"01"} />
                <Input type="number" placeholder={`${item === 1 ? "1234567895" : ""}`} />
              </InputGroup>
            </Fragment>
          ))}
          <div className="text-end">
            <Button size="sm" outline color="primary" className="button-effect">confirm</Button>
          </div>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default ChangeNumber;
